var render = function render(_c,_vm){return _c('div',{staticClass:"form-field tw-flex tw-flex-col tw-w-full md:tw-w-auto",class:[_vm.data.class,_vm.data.staticClass]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }